import { ActionIcon, Flex, Group, Stack, Text } from '@mantine/core';
import { IconFile, IconTrash } from '@tabler/icons-react';
import { FileRejection } from 'react-dropzone';

function AttachmentListItem({
  id,
  originalName,
  errors,
  onDelete
}: {
  id: string;
  originalName: string;
  errors?: FileRejection['errors'];
  onDelete: (id: string) => void;
}) {
  return (
    <Flex justify="space-between" align="center">
      <Group gap="xs" align="center">
        <IconFile size={16} />
        <Stack gap={0}>
          <Text size="sm" fw={600}>
            {originalName}
          </Text>
          {errors?.length && (
            <Text size="xs" c="red">
              {errors.map((err) => err.message).join(', ')}
            </Text>
          )}
        </Stack>
      </Group>

      <ActionIcon variant="subtle" color={'red'} onClick={() => onDelete(id)}>
        <IconTrash size="1rem" />
      </ActionIcon>
    </Flex>
  );
}

export default AttachmentListItem;
